import { BaseCameraApi, getAngleAdjustedDirection } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class BestaCameraApi extends BaseCameraApi {
    constructor(sceneManager, ipexViewer, entityManager, coreApi, canvas) {
        super(sceneManager, ipexViewer, entityManager, coreApi, canvas);
    }
    focusSolution(direction, margin, isMobile, shouldFocus) {
        const frames = this.coreApi.entities?.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const customDirection = getAngleAdjustedDirection(frames, { x: -0.4, y: -0.2 });
        // Larger solutions need a smaller margin, otherwise the camera will be too far away
        let customMargin;
        if (frames.length > 2) {
            customMargin = 0.01;
        }
        else {
            customMargin = 0.3;
        }
        return super.focusSolution(customDirection, customMargin, isMobile, shouldFocus);
    }
}
//# sourceMappingURL=BestaCameraApi.js.map